import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { take, finalize, tap, map, switchMap } from 'rxjs/operators';
import { Observable, combineLatest, of } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(public afs: AngularFirestore) { }


  public getUsers() {
    return this.afs.collection('users').valueChanges().pipe(take(1));
  }
  public getMoocs() {
    return this.afs.collection('moocs').valueChanges().pipe(take(1));
  }

  //getCategories
  public getCategories() {
    return this.afs.collection('categories_mooc').valueChanges().pipe(take(1));
  }

  public getEnrollment() {
    return this.afs.collection('enrollment').valueChanges().pipe(take(1));
  }

  public getCertify() {
    return this.afs.collection('certify').valueChanges().pipe(take(1));
  }

  public insertRDB() {
/*     var db = admin.database();
    let ref = db.ref('mirror-mooc-233515-59c10-admin')
    ref.set({
      username: 'arismel',
      email: 'aris@gmail.com'
    },
      function (error) {
        if (error) {
          // The write failed...
          console.log('error al insertar')
        } else {
          console.log('Data saved successfully!')
          // Data saved successfully!
        }

      }); */
  }

}
